import React from 'react';
import Main from './main/main';
import './styles/GlobalStyles.css'
import { ProductProvider } from './context/ProductContext';

const App = () => {
  return (
    <ProductProvider>
      <Main />
    </ProductProvider>
  );
}

export default App;
